import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText'
import { showPopup, closePopup } from '../../actions/uiActions'
import { deleteDbJob } from '../../actions/dbFunctionsActions'

function LookInsideZipFile(props) {
    const [fileData, setFileData] = useState({
          "name": "",
          "url": "",
          "containerName": "",
          "blobName": "",
          "identifier": "",
          "zipIndividualFiles": []
        })

    // trigger on component mount
    useEffect(() => {
        setFileData(JSON.parse(props.popupInfo.fileData))
    }, [])

    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }

    // This is the render logic, no need to declare another method is a functional component
    return (<Dialog
        open={true}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <CloseIcon onClick={handleClick} className="closePoup" />
        <DialogTitle id="alert-dialog-title" className="changepassdialog">
            {`Peek Inside`}
            {' '}
        </DialogTitle>
        <DialogContent>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} component="ul" aria-labelledby="nested-list-subheader">
                <ListItem>
                    <ListItemText primary={fileData["name"]} />
                </ListItem>
                {fileData.zipIndividualFiles.map((individualZipFile, zipIndex) => {
                    return <ListItem sx={{ pl: 4 }} key={`file-${zipIndex}`}>
                        <ListItemText primary={individualZipFile} />
                    </ListItem>
                })}
            </List>
        </DialogContent>
    </Dialog>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ showPopup, closePopup, deleteDbJob }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LookInsideZipFile)